export function getCorrectWords(state, words) {
    return words.filter(word => {
        return word.lettersPositions.every(letter => {
            return normaliceWord(state[letter.id].value) === normaliceWord(letter.value);
        });
    });
}

export function getIncorrectWords(state, words) {
    return words.filter(word => {
        return (
            word.lettersPositions.every(letter => state[letter.id].value !== "")
            &&
            word.lettersPositions.some(letter => normaliceWord(state[letter.id].value) !== normaliceWord(letter.value))
        )
    });
}

export function includeCorrectWord(state, correctWord) {
    correctWord.lettersPositions.map(
        letter => {
            state[letter.id].correct = true;
        }
    )
}

export function includeIncorrectWord(state, incorrectWord) {
    incorrectWord.lettersPositions.map(
        letter => {
            if (state[letter.id].correct !== true) state[letter.id].correct = false;
        }
    )
}

export function normaliceWord(word) {
    return word.trim().toUpperCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}